import WhiteGloveAILogo from '@/assets/branding/whitegloveai/whitegloveailogo.png';

const colors = {
  // Brand colors
  brand_primary: '#80A7D8',
  brand_primary_hover: '#608CC3', // −10 L, −8 S
  brand_primary_highlight: '#D6E4F5', // +23 L, +7 S
  brand_primary_mid: '#9CBCE3', // +8 L,  +2 S
  brand_primary_dark: '#3666A1', // −25 L, −3 S
  brand_secondary: '#5479B5', // hue +4°, −15 L, −13 S
  brand_accent_start: '#8FB4E1',
  brand_accent_end: '#8A83E8',
  brand_accent_light_start: '#EFF5FC',
  brand_accent_light_end: '#F0EEFF',
  brand_complementary_accent: 'rgb(225,140,58)',
  brand_auth_gradient_mid: '#5479B5',
  brand_auth_gradient_end: '#3666A1',
  brand_auth_warp_mid: '#9CBCE3',
};

export default {
  name: 'Whiteglove AI',
  isSAML: true,
  allowPersonalCourses: false,
  logo: WhiteGloveAILogo,
  colors,
};
